<mat-card appearance="outlined">
  <mat-card-title class="tw-flex tw-flex-row tw-justify-between">
    <span>{{ title }}</span>
    <span *ngIf="isDataEditable" class="link" (click)="manageCompartments()">
      {{ 'containerComponents.compartmentSelection.manageCompartment' | translate }}</span
    >
  </mat-card-title>
  <div class="section-description">
    {{ description }}
  </div>
  <div *ngIf="compartmentList.length; else noCompartmentTemplate" class="checkbox-group">
    <mat-chip-listbox class="mat-chip-list-stacked">
      <ng-container *ngFor="let group of compartmentList; let i = index">
        <div class="group">
          <div *ngIf="group.hubName?.length" class="group__title">
            {{ group.hubName | titlecase }}
          </div>
          <div *ngFor="let compartment of group.compartments; let j = index" class="group__role tw-flex tw-gap-x-5">
            <mat-chip-option
              [selectable]="false"
              [removable]="isDataEditable"
              class="tw-basis-3/4"
              (removed)="removeCompartment(i, compartment)"
            >
              {{ compartment.name }}
              <ui-svg-icon [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
            </mat-chip-option>
          </div>
        </div>
      </ng-container>
    </mat-chip-listbox>
  </div>
</mat-card>
<ng-template #noCompartmentTemplate>
  {{ 'common.field.please' | translate }}
  <span class="link" (click)="manageCompartments()">{{
    'containerComponents.compartmentSelection.addCompartment' | translate
  }}</span>
</ng-template>
